// NavBar.jsx
import React, { useEffect, useState } from "react";
import "../css/NavBar.css";

export default function Navbar({ variant = "landing" }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKeyDown = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  const navigate = (path) => {
    setOpen(false);
    window.location.href = path;
  };

  return (
    <div className="top-ui">
      {/* LEFT: LOGO */}
      <button
        className="top-ui-brand"
        onClick={() => navigate("/")}
        aria-label="Home"
      >
        <img src="/KHL-logo.svg" alt="Kentucky Home Living" />
      </button>

      {/* CENTER: spacer lane (keeps right cluster from overlapping center nav pills) */}
      <div className="top-ui-center" aria-hidden="true" />

      {/* RIGHT: cluster */}
      <div className="top-ui-right">

        <button
          className="top-ui-menu"
          aria-label="Open menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span className="top-ui-menu-icon" />
        </button>
      </div>

      {/* MENU DRAWER */}
      <div className={`menu-overlay ${open ? "open" : ""}`}>
        <button
          className="menu-scrim"
          aria-label="Close menu"
          onClick={() => setOpen(false)}
        />

        <aside className="menu-panel" role="dialog" aria-label="Menu">
          <button
            className="menu-close"
            aria-label="Close menu"
            onClick={() => setOpen(false)}
          >
            <span className="menu-close-icon" />
          </button>

          <nav className="menu-links">
            <button
              className={variant === "landing" ? "active" : ""}
              onClick={() => navigate("/")}
            >
              Home
            </button>

            <button
              className={variant === "about" ? "active" : ""}
              onClick={() => navigate("/about")}
            >
              About Me
            </button>

            <button
              className={variant === "neighborhoods" ? "active" : ""}
              onClick={() => navigate("/neighborhoods")}
            >
              Browse Homes
            </button>

            <button
              className={variant === "buyers" ? "active" : ""}
              onClick={() => navigate("/buyers")}
            >
              Buyers
            </button>

            <button
              className={variant === "sellers" ? "active" : ""}
              onClick={() => navigate("/sellers")}
            >
              Sellers
            </button>

            <button
              className={variant === "listings" ? "active" : ""}
              onClick={() => navigate("/listings")}
            >
              Properties
            </button>

            <button
              className={variant === "reviews" ? "active" : ""}
              onClick={() => navigate("/reviews")}
            >
              Reviews
            </button>

            <button
              className={variant === "blog" ? "active" : ""}
              onClick={() => navigate("/blog")}
            >
              Blog
            </button>

            <button
              className={variant === "contact" ? "active" : ""}
              onClick={() => navigate("/contact")}
            >
              Contact
            </button>
          </nav>
        </aside>
      </div>
    </div>
  );
}